import Vue from 'vue'
import Vuetify, { VList } from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'

import { preset } from './appPreset/preset'

Vue.use(Vuetify, {
  components: {
    VList,
  },
})

export default new Vuetify({
  preset,
})
